const LocalStorageService = {
  VERSION: 3,
  SESSION_USER_KEY: 'user_sessionUserId',
  ALERT_LIST_KEY: 'user_alertListState',
  DEVICE_LIST_KEY: 'user_deviceListState',
  saveStateToLocalStorage: (key, state) => localStorage.setItem(key, JSON.stringify(state)),
  getStateFromLocalStorage: (key) => JSON.parse(localStorage.getItem(key)),
  clearUserStorage: () => {
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key.startsWith('user_')) {
        localStorage.removeItem(key);
      }
    }
  },
};

export default LocalStorageService;
